<template>
  <v-container
    fill-height
    fluid
    class="pt-10 pa-5"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        align="center"
        justify="center"
      >
        <v-card
          tile
          elevation="10"
          width="50%"
          class="pa-10"
        >
          <v-img :src="splashScreenImage" />

          <h1
            class="pt-5"
            :style="{ color: textColor }"
          >
            {{ $t('description.splashTitle') }}
          </h1>

          <h2 class="font-weight-regular">
            {{ $t('description.splashMotto') }}
          </h2>
          <p class="font-weight-thin mt-2">
            {{ $t('description.splashText') }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SplashScreen',
  computed: {
    ...mapGetters({
      splashScreenImage: 'themeStore/getSplashScreen'
    }),
    textColor () {
      return this.$vuetify.theme.currentTheme.text
    }
  }
}
</script>
